import React, { Fragment } from "react";
import { withRouter, NavLink } from "react-router-dom";
import SideNav from "../SideNav";
import { getLocalStorageInfo } from "../../../utils";
import config from '../../../config';
import { smbcInstance } from "..";
function MntSideNav(props) {
	const asset = props.match.params?.asset
	const assetType = props.match.params?.assetType
	const archived = props?.location?.search.includes('archived-assets') ? '?archived-assets' : ''

	return (
		<Fragment>
		<ul className="list-unstyled">
				{assetType == 2 ? <SideNav to={`/${asset}/${assetType}/tech_spec/list${archived}`} title="Technical Specification" /> : null}
				{assetType == 2 && <SideNav to={`/${asset}/${assetType}/utilization/list${archived}`} title="Utilization" />}
				{assetType == 2 ? <SideNav to={`/${asset}/${assetType}/op_history/list${archived}`} title="Op. History" /> : null}
				{assetType == 1 ? null : <SideNav to={`/${asset}/${assetType}/shopVisit/list${archived}`} title="Shop Visits" />}
				{assetType == 1 ? <SideNav to={`/${asset}/${assetType}/amp/list${archived}`} title="AMP/MRB Compliance" /> : null}
				<SideNav to={`/${asset}/${assetType}/ad/list${archived}`} title={"AD Status"} />
				<SideNav to={`/${asset}/${assetType}/sb/list${archived}`} title={"SB Status"} />
				{assetType == 2 && <SideNav to={`/${asset}/${assetType}/engine_module/list${archived}`} title="Engine Module" />}
				{assetType == 1 ? null : <SideNav to={`/${asset}/${assetType}/llp/list${archived}`} title={"LLP Status"} />}
				{assetType == 2 && <SideNav to={`/${asset}/${assetType}/master_components/list${archived}`} title="Master Components" />}
				{assetType == 1 ? null : <SideNav to={`/${asset}/${assetType}/inventory/list${archived}`} title="Inventory List" />}
				{assetType == 2 && <SideNav to={`/${asset}/${assetType}/softTime/list${archived}`} title="Soft Time" />}
				{assetType == 1 ? <SideNav to={`/${asset}/${assetType}/ht/list${archived}`} title="Hard Time Components" /> : null}
				{assetType == 1 ? <SideNav to={`/${asset}/${assetType}/occm/list${archived}`} title="OC-CM Components" /> : null}
				{assetType == 1 ? <SideNav to={`/${asset}/${assetType}/sr/list${archived}`} title="Structure Repair" /> : null}
				{assetType == 1 ? <SideNav to={`/${asset}/${assetType}/mods/list${archived}`} title="Modifications" /> : null}
				{/* {smbcInstance ? null : <SideNav to={`/dashboard`} title="Analytics" />} */}
				{assetType == 2 && <li><NavLink className={props?.match?.path.includes("deleted") ? "active" : ""} class={props?.match?.path.includes("deleted") ? "active" : ""} to={`/${asset}/${assetType}/deleted/llp${archived}`}> Deleted Section</NavLink></li>}
			</ul>
		</Fragment>
	);
}

export default withRouter(MntSideNav);
